function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  opacity: 0.1,
  cx: 41,
  cy: 41,
  r: 41,
  fill: "#4293F6"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_15260:82402)"
}, React.createElement("path", {
  d: "M50.7455 42.2857C54.4445 42.2857 57.4432 39.2748 57.4432 35.5608C57.4432 31.8468 54.4445 28.836 50.7455 28.836C47.0465 28.836 44.0479 31.8468 44.0479 35.5608C44.0479 39.2748 47.0465 42.2857 50.7455 42.2857Z",
  fill: "#2F66E3"
}), React.createElement("path", {
  d: "M35.8729 35.4748C38.4885 32.8486 38.4885 28.5907 35.8729 25.9645C33.2573 23.3383 29.0166 23.3383 26.401 25.9645C23.7854 28.5907 23.7854 32.8486 26.401 35.4748C29.0166 38.1011 33.2573 38.1011 35.8729 35.4748Z",
  fill: "#2F66E3"
}), React.createElement("path", {
  d: "M43.1224 44.5164C40.9817 41.5122 37.9329 39.6315 34.4949 39.6315H27.7161C21.2293 39.6315 15.9668 46.5355 15.9668 55.0433H35.3057C36.4896 50.1421 39.4086 46.2587 43.1224 44.5164Z",
  fill: "#2F66E3"
}), React.createElement("path", {
  d: "M64.9999 58.9919C64.6675 51.3715 59.9158 45.3143 54.1344 45.3143H47.3557C46.2175 45.3166 45.0918 45.5521 44.0474 46.0063C45.5326 48.7748 46.2995 51.8743 46.2773 55.0188H37.0903C36.747 56.3173 36.5458 57.6496 36.4902 58.9919H64.9999Z",
  fill: "#2F66E3"
}), React.createElement("path", {
  d: "M46.2778 55.0188C46.3 51.8743 45.5332 48.7748 44.048 46.0063C40.8045 47.3903 38.226 50.7527 37.0908 55.0188H46.2778Z",
  fill: "#2F66E3"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_15260:82402"
}, React.createElement("rect", {
  width: 49,
  height: 35,
  fill: "white",
  transform: "translate(16 24)"
})));

var SvgProdCands = function SvgProdCands(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProdCands, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prod_cands.473ed28c.svg";
export { ForwardRef as ReactComponent };